import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative py-32 md:py-40 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Rich%20warm%20toned%20artistic%20flat%20lay%20of%20carefully%20arranged%20fashion%20pieces%20including%20a%20cognac%20leather%20tote%20bag%20folded%20ivory%20linen%20shirt%20pair%20of%20tortoiseshell%20wayfarer%20sunglasses%20and%20a%20vintage%20style%20brass%20compass%20scattered%20on%20a%20dark%20walnut%20wooden%20desk%20with%20soft%20dramatic%20overhead%20spotlight%20creating%20deep%20shadows%20editorial%20product%20photography%20moody%20atmospheric%20aesthetic%20high%20contrast%20refined%20composition&width=1920&height=1080&seq=cta-bg-v2&orientation=landscape"
          alt="Curated Superbuy Spreadsheet product collection on wooden surface"
          className="w-full h-full object-cover object-top"
        />
      </div>
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-foreground-950/40"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-background-50 leading-[1.15] tracking-wide">
          SMARTER SHOPPING
          <br />
          STARTS HERE
        </h2>
        <p className="mt-6 text-background-100/80 text-base md:text-lg leading-relaxed max-w-xl mx-auto">
          Organized research. Curated finds.
          <br />
          Direct links to the best products.
        </p>
        <div className="mt-10 flex justify-center">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-0 pl-1 pr-6 py-3 bg-foreground-950 text-background-50 font-label font-semibold text-sm rounded-full hover:bg-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 mr-3">
              <i className="ri-shopping-bag-line text-background-50 text-lg"></i>
            </span>
            SUPERBUY SHEET
            <i className="ri-arrow-right-up-line text-lg ml-2 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}